import {useEffect, useState} from "react";
import { useAppSelector } from "redux-share/hooks";
import { IUniEmojiProps } from "interfaces";
import { shallowEqual } from 'react-redux'
import dynamic from "next/dynamic";

const AnimatedEmoji = dynamic(() => import("./animatedEmoji/AnimatedEmoji"));

const UniEmoji = ({EmojiList, direction , normalizeCoefficient}: IUniEmojiProps) => {

    const [emojiBucket, setEmojiBucket] = useState<{ code: string, id: number }[]>([]);
    const [shuffledEmojiBucket, setShuffledEmojiBucket] = useState<{ code: string, id: number }[]>([]);
    const [timeoutIds, setTimeoutIds] = useState<any[]>([]);
    const { config } = useAppSelector(({ videoData: { config } }) => ({ config }), shallowEqual);

    const RetrievalAndShuffle = () => {
        const AllEmoji: { code: string; count: number }[] = [];
        EmojiList.forEach((item) => {
            Array.from((Array(item.count * normalizeCoefficient).keys())).map((emojiNumber, i) => AllEmoji.push(item))
        })
        let ShuffleEmoji = (AllEmoji.map((a) => ({
            sort: Math.random(),
            value: a
        })).sort((a, b) => a.sort - b.sort).map((a) => a.value)).map((item, i) => ({code: item.code, id: i}))
        setShuffledEmojiBucket(ShuffleEmoji);
    }

    const SetEmojiBucketId = async (index: number, ceilLimit: number) => {
        if (index < ceilLimit) {
            const timeoutId = await setTimeout(() => {
                setEmojiBucket((prev) => [...prev, shuffledEmojiBucket[index]]);
            }, (config.get_interval / shuffledEmojiBucket.length) * 1000 * index);
            await setTimeoutIds((prev) => [...prev, timeoutId]);
            SetEmojiBucketId(index + 1, ceilLimit);
        }
    }

    useEffect(() => {
        setShuffledEmojiBucket([]);
        setEmojiBucket([]);
        RetrievalAndShuffle();
    }, [EmojiList]);

    useEffect(() => {
        if (shuffledEmojiBucket.length > 0) SetEmojiBucketId(0, shuffledEmojiBucket.length);
        return () => {
            if (timeoutIds.length > 0) {
                timeoutIds.forEach((id) => clearTimeout(id));
                setTimeoutIds([]);
            }
        }
    }, [shuffledEmojiBucket]);

    return (
        <>
            {
                emojiBucket.length > 0 ? emojiBucket.map((item, index) => {
                        return (
                            <div key={index}>
                                <AnimatedEmoji direction={direction} emojiCode={item.code}/>
                            </div>
                        )
                    }) :
                    <></>
            }
        </>
    )
}

export default UniEmoji;